export default "__VITE_ASSET__06519115__"